import styled from "styled-components";
import { Link } from "react-router-dom";

export const NotFoundWrap = styled.section`
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 140px ${({ theme }) => theme.spacing["2xl"]}
    ${({ theme }) => theme.spacing["4xl"]};
  background: ${({ theme }) => theme.colors.navy};
  text-align: center;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      radial-gradient(
        circle at 50% 0%,
        rgba(112, 141, 171, 0.22) 0%,
        transparent 55%
      ),
      radial-gradient(
        circle at 15% 100%,
        rgba(201, 169, 110, 0.1) 0%,
        transparent 50%
      ),
      radial-gradient(
        circle at 85% 80%,
        rgba(112, 141, 171, 0.12) 0%,
        transparent 45%
      );
    pointer-events: none;
  }

  & > * {
    position: relative;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 120px ${({ theme }) => theme.spacing.lg}
      ${({ theme }) => theme.spacing["2xl"]};
  }
`;

export const Inner = styled.div`
  max-width: 640px;
  margin: 0 auto;
`;

export const Eyebrow = styled.p`
  font-family: ${({ theme }) => theme.fonts.caps};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  letter-spacing: ${({ theme }) => theme.letterSpacings.widest};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primaryLight};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const ErrorCode = styled.div`
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: clamp(6rem, 18vw, 14rem);
  font-weight: ${({ theme }) => theme.fontWeights.light};
  line-height: 1;
  letter-spacing: ${({ theme }) => theme.letterSpacings.tight};
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.white} 0%,
    ${({ theme }) => theme.colors.primaryLight} 60%,
    ${({ theme }) => theme.colors.primary} 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const Title = styled.h1`
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: clamp(2rem, 4vw, ${({ theme }) => theme.fontSizes["5xl"]});
  font-weight: ${({ theme }) => theme.fontWeights.light};
  color: ${({ theme }) => theme.colors.white};
  letter-spacing: ${({ theme }) => theme.letterSpacings.tight};
  margin-bottom: ${({ theme }) => theme.spacing.lg};

  em {
    font-style: italic;
    color: ${({ theme }) => theme.colors.primaryLight};
  }
`;

export const Description = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: rgba(255, 255, 255, 0.6);
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
  max-width: 480px;
  margin: 0 auto ${({ theme }) => theme.spacing["2xl"]};
`;

export const Actions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  justify-content: center;
  flex-wrap: wrap;
`;

const buttonBase = `
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 16px 40px;
  border-radius: 8px;
  transition: all 300ms ease;
`;

export const PrimaryButton = styled(Link)`
  ${buttonBase}
  font-family: ${({ theme }) => theme.fonts.caps};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};

  &:hover {
    background: ${({ theme }) => theme.colors.primaryDark};
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(112, 141, 171, 0.35);
  }
`;

export const SecondaryButton = styled(Link)`
  ${buttonBase}
  font-family: ${({ theme }) => theme.fonts.caps};
  background: transparent;
  color: ${({ theme }) => theme.colors.white};
  border: 1px solid rgba(255, 255, 255, 0.25);

  &:hover {
    border-color: ${({ theme }) => theme.colors.primaryLight};
    color: ${({ theme }) => theme.colors.primaryLight};
    transform: translateY(-2px);
  }
`;
